import { handleSlideDistance } from "@/components/BasicLayout/BasicHeader/LocationMask";
const chunkArray = (array: any[], size: number) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const LayoutGrid: React.FC<any> = ({ list, style = {} }) => {
  const chunkList = chunkArray(list, 3);
  const itemsNode = useRef<any>(null);
  const titleNodeArray: any = {};
  const valueNodeArray: any = {};

  const animateTitleNode = (array: any) => {
    Object.values(array).map(({ current }: any) => {
      handleSlideDistance({
        speed: 0.01,
        end: current?.parentElement?.parentElement?.clientWidth - current?.clientWidth,
      })(current);
    });
  };

  const animateValueNode = (array: any) => {
    Object.values(array).map(({ current }: any) => {
      handleSlideDistance({
        speed: 0.01,
        end: current?.parentElement?.clientWidth - current?.clientWidth,
      })(current);
    });
  };
  useEffect(() => {
    animateTitleNode(titleNodeArray);
    animateValueNode(valueNodeArray);
  }, []);
  return (
    <WeatherMainContent className="content" style={style}>
      {chunkList.map((array, outerIndex) => {
        return (
          <div
            key={outerIndex}
            className="grid grid-cols-[repeat(3,33.33%)] border-b-1 border-b-solid border-b-[rgba(255,255,255,0.18)] last:border-b-none"
          >
            {array.map((item, innerIndex) => {
              titleNodeArray[outerIndex + "_" + innerIndex] = useRef();
              valueNodeArray[outerIndex + "_" + innerIndex] = useRef();
              return (
                <div
                  key={innerIndex}
                  className="h-100 relative text-center w-full overflow-hidden after:content-[''] after:block after:w-1 after:h-80% after:bg-[rgba(255,255,255,0.18)] after:absolute after:top-50% after:translate-[0,-50%] first:after:display-[none]"
                >
                  <div
                    className="w-[calc(100%-16px)] p-[5px_0] overflow-hidden flex flex-col gap-y-5 items-center font-size-12 absolute top-50% left-50% translate-[-50%] whitespace-nowrap"
                    ref={itemsNode}
                  >
                    <div className="w-full">
                      <div className="w-full items-center">
                        <WeatherImage className="w-20" src={item?.icon} />
                      </div>
                      {/* <WeatherImage className='w-20' src={item?.icon} /> */}
                      <AnimateSlide ref={titleNodeArray[outerIndex + "_" + innerIndex]} $playState="paused">
                        {item.title}
                      </AnimateSlide>
                    </div>
                    {/* <p>{item.value}</p> */}
                    <AnimateSlide ref={valueNodeArray[outerIndex + "_" + innerIndex]} $playState="paused">
                      {item.value}
                    </AnimateSlide>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </WeatherMainContent>
  );
};
export default LayoutGrid;
/* 
写法1：使用阿里字体图标 
{renderIconFont("icon-yyhumidity2", { fontSize: "30px" })}
写法2：直接把svg文件当组件渲染 
import HumiditySvg from "@assets/icons/Humidity.svg?react";
<HumiditySvg />
写法3：使用封装的组件 推荐 
<SvgIcon name="Humidity" size="30" />
*/
